import React, { Component } from 'react';
// import { CKEditor } from '@ckeditor/ckeditor5-react';
// import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import PageTitle from "../../../layouts/PageTitle";

const baseURLS = window.location.origin === 'https://admin.astrocall.live'
  ? 'https://api.astrocall.live/api/'
  : 'https://liveapi.astrocall.live/api/';

class CkEditor extends Component {
    constructor(props) {
        super(props);
        this.state = {
            editorData: ''
        };
    }

    // Custom upload adapter
    createUploadAdapter(loader) {
        return {
            upload: () => {
                return new Promise((resolve, reject) => {
                    const formData = new FormData();
                    loader.file.then(file => {
                        formData.append('image', file);
                        // Replace this URL with your actual upload URL
                        // fetch('https://api.astrocall.live/api/Image/Insert_Image', {
                         fetch(`${baseURLS}Image/Insert_Image`, {
                            method: 'POST',
                            body: formData,
                            headers: {
                                // Include any headers your server requires
                            },
                        })
                            .then(response => {
                                if (!response.ok) {
                                    throw new Error('Upload failed');
                                }
                                return response.json();
                            })
                            .then(data => {
                                // Resolve with the URL of the uploaded image
                                resolve({ default: data.url });
                            })
                            .catch(error => {
                                reject(error);
                            });
                    });
                });
            }
        };
    }

    render() {
        return (
            <>
                <PageTitle activeMenu="CkEditor" motherMenu="Form" pageContent="CkEditor" />
                <div className="row">
                    <div className="col-xl-12 col-xxl-12">
                        <div className="card">
                            <div className="card-header">
                                <h4 className="card-title">Form CkEditor</h4>
                            </div>
                            <div className="card-body custom-ekeditor">
                                
                            </div>
                        </div>
                    </div>
                </div>
            </>
        );
    }
}

export default CkEditor;
